import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { conversationsQuery } from "modules/conversations/lib/conversationsQuery"
import { DataResponse, GenerateFakeCustomerResponseDataSchema } from "schema"
import { z } from "zod"
import { customersQuery } from "../lib/customersQuery"

type Response = DataResponse<z.infer<typeof GenerateFakeCustomerResponseDataSchema>>

type Props = {
  campaignId?: string
}

export function useGenerateFakeCustomerMutation(props: Props = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const response = await axios.post<Response>(`/customers/fake`, {
        campaignId: props.campaignId,
      })

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: customersQuery().queryKey })
      queryClient.invalidateQueries({ queryKey: conversationsQuery().queryKey })
    },
  })
}
